var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconNotification32(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.908 5.254A7.75 7.75 0 008.404 13v4.507l-.12.06C6.952 18.265 6.25 19.438 6.25 21l.005.188c.077 1.54 1.11 2.441 2.848 2.56l3.349.002.018.13c.297 1.856 1.582 2.869 3.684 2.869l.23-.004c1.967-.073 3.169-1.078 3.454-2.865l.018-.13h3.298c1.858-.128 2.9-1.098 2.9-2.75l-.004-.22c-.064-1.452-.76-2.548-2.026-3.213l-.12-.059V13a7.75 7.75 0 00-7.75-7.75l-.246.004zm.246 1.496a6.25 6.25 0 016.25 6.25v5a.75.75 0 00.489.703c1.143.425 1.661 1.148 1.661 2.297 0 .814-.39 1.178-1.452 1.252l-3.948-.002a.75.75 0 00-.75.75c0 1.585-.664 2.249-2.25 2.249-1.585 0-2.25-.664-2.25-2.249a.75.75 0 00-.75-.75h-4C8.141 22.179 7.75 21.816 7.75 21c0-1.148.519-1.871 1.665-2.297a.75.75 0 00.49-.703v-5a6.25 6.25 0 016.25-6.25z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotification32);
export default __webpack_public_path__ + "static/media/icon-notification-32.2584005a.svg";
export { ForwardRef as ReactComponent };